import { getArgumentValue } from '@shared/workflow/getArgumentValue.js';

const parseLookupArguments = async ({ args = {}, stepArgs = {}, previousArgs, actionId, app, responses }) => {
  const result = {};
  let argsChanged = false;

  const argsArray = Object.keys(args);
  const actionArgs = app?.actions?.find((n) => n.id === actionId)?.arguments;

  for (let i = 0; i < argsArray.length; i++) {
    const key = argsArray[i];
    const arg = args[key];

    if (!arg.sourceArgumentId) {
      result[key] = arg;
      continue;
    }

    const argDef = actionArgs?.find((n) => n.id === arg.sourceArgumentId);
    const argValue = stepArgs[argDef?.key];
    const argFormattedValue = await getArgumentValue({ arg: argValue, def: argDef, responses });
    const previousArgValue = previousArgs?.[key]?.value;

    if (argFormattedValue !== previousArgValue) {
      argsChanged = true;
    }

    result[key] = { ...arg, value: argFormattedValue };
  }

  return { args: result, argsChanged };
};

export default parseLookupArguments;
